import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BetPlacePayload } from '@/store/api/betPlaceApi';

interface BetState {
  betDetails: Partial<BetPlacePayload> | null;
}

const initialState: BetState = {
  betDetails: null,
};

const betSlice = createSlice({
  name: 'bet',
  initialState,
  reducers: {
    setBetDetails: (state, action: PayloadAction<Partial<BetPlacePayload>>) => {
      state.betDetails = action.payload;
    },

    setBetRate: (state, action: PayloadAction<number>) => {
      if (state.betDetails) {
        state.betDetails.rate = action.payload;
      }
    },

    setBetStake: (state, action: PayloadAction<number>) => {
      if (state.betDetails) {
        state.betDetails.stake = action.payload;
      }
    },

    resetBetDetails: (state) => {
      state.betDetails = null;
    },
  },
});

export const { setBetDetails, setBetRate, setBetStake, resetBetDetails } = betSlice.actions;

export default betSlice.reducer;
